// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1z225","title":"Images45_title__igMag","images":"Images45_images__1SB1L"};